import { SxProps, Theme } from '@mui/material';

export const CatalogEntryListFacetChipsPrimarySX: SxProps<Theme> = {
	color: 'white',
	fontWeight: 'bold',
	mr: 1,
	borderRadius: '22px',
	height: '44px',
	fontSize: '15px',
	marginBottom: { xs: '17px', md: '0px' },
	width: 'fit-content',
	textTransform: 'capitalize',
};

export const CatalogEntryListFacetChipsSecondarySX: SxProps<Theme> = {
	height: '29px',
};

export const CatalogEntryListFacetChipsCloseIconFrameSX: SxProps<Theme> = {
	'&:hover': {
		bgcolor: 'transparent',
	},
	padding: 0,
};

export const CatalogEntryListFacetChipsCloseIconSX: SxProps<Theme> = {
	color: '#333',
	width: '20px',
	height: '20px',
};
